<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-6 mt-6">
          <label class="label-input">Padding</label>
          <div class="group-item">
            <v-row>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.top" label="Top Padding" />
              </v-col>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
              </v-col>
            </v-row>
          </div>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields.textColor"
                @change="e => (fields.textColor = e.target.value)"
              />
              <v-text-field v-model="fields.textColor" label="Text Color" :hide-details="true" />
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['background-section'].color"
                @change="e => (fields['background-section'].color = e.target.value)"
              />
              <v-text-field
                v-model="fields['background-section'].color"
                label="Background Color"
                :hide-details="true"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="group-item">
              <v-checkbox v-model="fields['container-content'].showStyle" label="Container style" />
              <div class="d-flex align-center gap-3" v-if="fields['container-content'].showStyle">
                <input
                  type="color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['container-content'].background"
                  @change="e => (fields['container-content'].background = e.target.value)"
                />
                <v-text-field
                  v-model="fields['container-content'].background"
                  label="Container background"
                  :hide-details="true"
                />
              </div>
            </div>
          </v-col>
        </v-row>

        <div class="mb-6 mt-6">
          <label class="label-input">Title Card</label>
          <div class="group-item">
            <v-checkbox v-model="fields['show-title']" label="Show title" class="mt-0 pt-0" hide-details />
            <ckeditor :editor="editor" v-model="fields['title-card']" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-5 mt-6">
          <div class="d-flex justify-space-between align-center">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label style="margin-bottom: 0" class="label-input">Accordions</label>
              <input type="checkbox" v-model="fields.itemAccordions.dataShowAccordion" />
            </div>
            <v-btn small text color="primary" @click="handleAddAccordion">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Accordion</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields.itemAccordions.listItem" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span>Accordion {{ i + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveAccordion(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field v-model="item.title" label="Title" />
                <ckeditor :editor="editor" v-model="item.answer" :config="editorConfig" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

export default {
  name: 'PolicyYuriAccordionSectionEditor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Policy Yuri Accordion Section',
        enableAnchor: false,
        textColor: '#000000',
        padding: { top: false, bottom: false },
        'background-section': { color: '#ffffff' },
        'container-content': { showStyle: false, background: '#ffffff' },
        'show-title': true,
        'title-card': '<h2>Order Policy</h2><p></p>',
        itemAccordions: {
          dataShowAccordion: true,
          listItem: [],
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        'show-title': this.fields['show-title'] !== false,
      };
      const updateHtml = updateHtmlFromData.sectionPolicyYuriAccordion(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddAccordion() {
      this.fields.itemAccordions.listItem.push({
        title: '',
        answer: '',
      });
    },
    handleRemoveAccordion(index) {
      this.fields.itemAccordions.listItem.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
